'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _modal = require('modal');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// const Button = props => <button className={ClassList.join("btn",props.className)} onClick={props.onClick}>{props.children}</button>

var PromoBanner = function (_Modal) {
	_inherits(PromoBanner, _Modal);

	function PromoBanner() {
		_classCallCheck(this, PromoBanner);

		return _possibleConstructorReturn(this, (PromoBanner.__proto__ || Object.getPrototypeOf(PromoBanner)).apply(this, arguments));
	}

	_createClass(PromoBanner, [{
		key: 'classList',
		get: function get() {
			return _get(PromoBanner.prototype.__proto__ || Object.getPrototypeOf(PromoBanner.prototype), 'classList', this).concat('smart-start-modal');
		}
	}, {
		key: 'content',
		get: function get() {
			return _react2.default.createElement(
				'div',
				null,
				this.props.image ? _react2.default.createElement('img', { src: this.props.image }) : null,
				_react2.default.createElement(
					'h1',
					{ className: 'uppercase title' },
					this.props.title
				),
				_react2.default.createElement(
					'h3',
					{ className: 'uppercase' },
					this.props.body
				),
				_react2.default.createElement(
					'a',
					{ className: 'btn', href: this.props.target },
					this.props.linkTitle || 'Learn More'
				)
			);
		}
	}], [{
		key: 'setDefaultContent',
		value: function setDefaultContent(content) {
			this.defaultContent = content;
		}
	}, {
		key: 'show',
		value: function show(props) {
			props = Object.assign({}, props || {});

			this.showModal(_react2.default.createElement(PromoBanner, _extends({}, this.defaultContent, props)));
		}
	}]);

	return PromoBanner;
}(_modal2.default);

exports.default = PromoBanner;


PromoBanner.defaultContent = {};